// Member names must match TetaConnector.Contracts/SerisTetaConnector.Contracts AgreementImportScope exactly;
// both contracts serialize this enum as a JSON string via JsonStringEnumConverter, not as a number.
export enum AgreementImportScope {
    ActiveFromRegistry = 'ActiveFromRegistry',
    AllFromRegistry = 'AllFromRegistry',
    AllFromAllRegistries = 'AllFromAllRegistries',
    None = 'None',
}

export interface ImportFromExternalSystemRequest {
    RegistrationNumber: string;
    CardNumber: string;
    ImportAddress: boolean;
    Draft: boolean;
    EmploymentAgreementScope: AgreementImportScope;
    MandateAgreementScope: AgreementImportScope;
}

export interface ImportFromExternalSystemResponse {
    IsSuccess?: boolean;
    ErrorCodes?: string[];
    Error?: string;
}
